<main class="main" id="top">
  <div class="container" data-layout="container">
    <div class="row flex-center min-vh-100 py-6">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
        <div class="card login-card-bg login-card-size">
          <div class="card-body p-4 p-sm-5">
            <div class="row text-left justify-content-between align-items-center mb-2">
              <div class="col-auto">
                <h5>Log in HMS</h5>
              </div>
            </div>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <input class="form-control" type="email" placeholder="Email" formControlName="email" tabindex="1" 
                       [ngClass]="{ 'is-invalid': submitted && loginFormControl.email.errors }"  autocomplete="new-password" />
                <div *ngIf="submitted && loginFormControl.email.errors" class="invalid-feedback">
                  <div *ngIf="loginFormControl.email.errors.required">Email is required</div>
                </div>
              </div>
              <div class="form-group">
                <input class="form-control" type="password" placeholder="Password" formControlName="password" tabindex="2" 
                       [ngClass]="{ 'is-invalid': submitted && loginFormControl.password.errors }"  autocomplete="new-password"/>
                <div *ngIf="submitted && loginFormControl.password.errors" class="invalid-feedback">
                  <div *ngIf="loginFormControl.password.errors.required">Password is required</div>
                </div>
              </div>
              <div class="row justify-content-between align-items-center">
                <div class="col-auto"><a class="fs--1" [routerLink]="'/forgot-password'">Forgot Password?</a></div>
              </div>
              <div class="form-group">
                <button class="btn btn-primary btn-block mt-3">Log in</button>
              </div>
            </form>
          </div>
        </div>
        <div *ngIf="loginForm.errors?.invalidLogin" class="alert alert-danger mt-3 mb-0">
          {{errorMessage}}
        </div>
      </div>
    </div>
  </div>
</main>
